"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _copyPublic = require("@/libs/copyPublic");
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'i-copyright',
  data: function data() {
    return {
      copyright: 'Copyright © 2025 西安众邦网络科技有限公司',
      copyrightNew: ''
    };
  },
  mounted: function mounted() {
    this.getVersion();
  },
  methods: {
    getVersion: function getVersion() {
      var _this = this;
      (0, _copyPublic.getCopyrightInfo)().then(function (res) {
        var data = res || {};
        _this.copyrightNew = data.companyName ? data.companyName : _this.copyright;
      });
    }
  }
};